import { useDialogState } from "@resource/atlas";
import { useCallback } from "react";
import useLeaveConfirmation from "react-hooks/useLeaveConfirmation";

export function useDialogWithLeaveConfirmation({
  open,
  setOpen,
  showConfirmation,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  showConfirmation: boolean;
}) {
  const confirmationHandler = useLeaveConfirmation(
    "You have unsaved changes. Are you sure you want to leave?",
    !!open && showConfirmation
  );

  const wrappedSetOpen = useCallback(
    (newOpen: boolean) => {
      const isClosing = !newOpen;
      if (isClosing) {
        if (
          (confirmationHandler?.showConfirmation &&
            confirmationHandler?.triggerConfirmation()) ||
          !confirmationHandler?.showConfirmation
        ) {
          setOpen(false);
        }
      } else {
        setOpen(true);
      }
    },
    [confirmationHandler, setOpen]
  );

  const dialogState = useDialogState({
    open,
    setOpen: wrappedSetOpen,
  });

  return dialogState;
}
